
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 87.72 87.95"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M81.32 31l-6.46-11.08v-.05a2.2 2.2 0 00-3-.79l-5 2.9-55.14 32a2.12 2.12 0 00-1 1.23l-4.29 9.58a2.34 2.34 0 00-.26.58 2.21 2.21 0 001.57 2.69h.2a2.23 2.23 0 00.36 0h.06l10.42 1a2 2 0 00.48.06h.07a2.32 2.32 0 00.46-.06h.13a2.25 2.25 0 00.45-.19l52-30.14c.09 0 .18-.07.27-.12a2 2 0 00.3-.21l2.61-1.52 5-2.91a2.19 2.19 0 001-1.34 2.14 2.14 0 00.07-.43 2.26 2.26 0 00-.3-1.2zM18.77 64.78l-7.26-.71 3-6.66 49.67-28.86 4.3 7.38zm54.56-31.66l-1 .6L68 26.35l1-.6 3.1-1.81 4.3 7.38z","fill":"#fff","data-name":"Livello 2"}})])
          )
        }
      }
    